import _ from 'lodash'

export function resolveItemLancamentoData(data, cobertura) {
  return {
    tipo: _.get(data, 'tipo', _.get(cobertura, 'itemLancamento.tipo', null)),
    oidTipo: _.get(data, 'oidTipo', _.get(cobertura, 'itemLancamento.oidTipo', null)),
    descricao: _.get(data, 'descricao', _.get(cobertura, 'descricao', '')),
    descricaoServico: _.get(data, 'descricaoServico', _.get(cobertura, 'descricaoServico', null)),
    oidGrupo: _.get(data, 'oidGrupo', _.get(cobertura, 'oidGrupo', null)),
    entradaSaida: _.get(data, 'entradaSaida', _.get(cobertura, 'entradaSaida', null)),
  }
}

export function resolveDescricaoServicoFallback(data, cobertura) {
  return (
    _.get(cobertura, 'descricaoServico', null) ||
    _.get(data, 'descricaoServico', null) ||
    _.get(data, 'descricao', null) ||
    _.get(cobertura, 'descricao', '')
  )
}

export function buildTaxaFromContratoItem(data, cobertura) {
  const resolvedData = resolveItemLancamentoData(data, cobertura)
  return {
    itemLancamento: {
      tipo: _.get(resolvedData, 'tipo', null),
      oidTipo: _.get(resolvedData, 'oidTipo', null),
    },
    descricao: _.get(resolvedData, 'descricao', ''),
    descricaoServico: resolveDescricaoServicoFallback(resolvedData, cobertura),
    oidGrupo: _.get(resolvedData, 'oidGrupo', null),
    entradaSaida: _.get(resolvedData, 'entradaSaida', null),
    valor: _.get(cobertura, 'valor', 0),
    valorTotal: _.get(cobertura, 'quantidade', 0) * _.get(cobertura, 'valor', 0),
    quantidade: _.get(cobertura, 'quantidade', 1),
  }
}

export function resolveDescricaoServicoNFSe(descricaoServicoNFSeAtual, descricaoServicoItem) {
  if (descricaoServicoNFSeAtual && _.trim(descricaoServicoNFSeAtual).length > 0) {
    return descricaoServicoNFSeAtual
  }
  return descricaoServicoItem || descricaoServicoNFSeAtual
}

export const MENSAGEM_ARQUIVO_RETORNO_EM_PROCESSAMENTO =
  'O processamento do arquivo está demorando mais que o esperado, mas continua em andamento. ' +
  "Verifique o resultado mais tarde na tela de 'Consulta de Baixas'. Não é necessário enviar o arquivo novamente."

// O processamento do arquivo retorno e sincrono e pode levar minutos. O nginx corta a requisicao
// com 504 (corpo HTML) antes de o backend terminar, e o backend segue processando e baixando os
// lancamentos. Sem resposta HTTP (conexao cortada no caminho) e o mesmo caso. Nos dois, nao ha
// arquivo para baixar e "erro" levaria o operador a reenviar o arquivo.
export function resolveMensagemFalhaArquivoRetorno(err) {
  const semResposta = Boolean(err?.request) && !err?.response
  if (semResposta || err?.response?.status === 504) {
    return { severity: 'warn', message: MENSAGEM_ARQUIVO_RETORNO_EM_PROCESSAMENTO }
  }
  const message = err?.response?.data || 'Ocorreu um erro no processamento do arquivo. Por favor, tente novamente.'
  return { severity: 'error', message }
}

// Estado vazio do painel do Pix Imediato (status + QR + copia-e-cola), comum às telas de
// Lançamento e de Venda.
export const initialStatePixImediato = {
  txid: '',
  status: '',
  statusProvider: '',
  pixCopiaECola: '',
  qrCodeBase64: '',
  expiracao: '',
  erro: '',
}
